import axios from 'axios';
import { VehicleComponent } from '../types/Vehicle';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

class VehicleComponentService {
  private handleError(error: any): Error {
    if (error.response) {
      const message = error.response.data?.error || error.response.data?.message || 'An error occurred';
      return new Error(message);
    } else if (error.request) {
      return new Error('No response from server. Please check your connection.');
    } else {
      return new Error(error.message || 'An unexpected error occurred');
    }
  }

  async getComponents(vehicleId: number): Promise<VehicleComponent[]> {
    try {
      const response = await axios.get(`${BASE_URL}/vehicles/${vehicleId}/components`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createComponent(vehicleId: number, data: Partial<VehicleComponent>): Promise<VehicleComponent> {
    try {
      const response = await axios.post(`${BASE_URL}/vehicles/${vehicleId}/components`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateComponent(vehicleId: number, id: number, data: Partial<VehicleComponent>): Promise<VehicleComponent> {
    try {
      const response = await axios.put(`${BASE_URL}/vehicles/${vehicleId}/components/${id}`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteComponent(vehicleId: number, id: number): Promise<void> {
    try {
      await axios.delete(`${BASE_URL}/vehicles/${vehicleId}/components/${id}`);
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new VehicleComponentService();
